import React from "react";
import { AboutUs } from "./styled";

export default function SobreNos() {

    return (
        <AboutUs>
            <aside className="aboutUs">
                <h2>Sobre nós</h2>
                <p>
                    Com mais de 20 anos de expertise, somos referência em roupas de academia e suplementos no Brasil e, desde o princípio, destacamo-nos pela inovação e qualidade tanto na fabricação quanto na pesquisa. Ao longo dos anos, expandimos consideravelmente e hoje contamos com uma equipe de mais de 500 entusiastas do fitness, trabalhando incansavelmente para oferecer aos consumidores produtos de vanguarda em vestuário esportivo e suplementação de última geração. Nossa busca incessante por excelência e promoção da saúde nos levou a desenvolver marcas que inspiram e transformam. Atualmente, o Grupo FitnessBlast engloba marcas como: SportWear, oferecendo roupas de alta performance para quem busca melhorar seu desempenho nos treinos diários; PowerFuel, destinada a atletas que buscam alcançar o máximo desempenho e resultados; e NutriFit, que promove um estilo de vida saudável e equilibrado através de suplementos de alta qualidade, livres de substâncias artificiais.
                </p>
            </aside>
        </AboutUs>

    )
}